import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { moduli } from '../../config';
import notify from 'devextreme/ui/notify';
import { RadniNaloziDokumentiService } from './radni-nalozi-dokumenti.service';

@Component({
  selector: 'app-radni-nalozi-dokumenti',
  templateUrl: './radni-nalozi-dokumenti.component.html',
  styleUrls: ['./radni-nalozi-dokumenti.component.scss']
})
export class RadniNaloziDokumentiComponent implements OnInit {

  rnDokumenti: any = [];
  idRadniNalog: number;
  popisDokumenataRN: any = [];
  poruka: string;

  datumOd = moment().subtract(1, 'days');
  datumDo = moment();
  datumOdFormatiran: string = this.datumOd.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo.format('YYYY-MM-DD');


  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: RadniNaloziDokumentiService) {


    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().radninaloziDokumenti;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA

  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onCellPrepared(options) {
    //console.log(options);
    if (options.rowType == "data") {
      if (options.column.dataField === "smjena_idsmjena"){
        if (options.value == '1') {
          options.cellElement.classList.add('bojaSmjena1');
        }
        if (options.value == '2') {
          options.cellElement.classList.add('bojaSmjena2');
        }
        if (options.value == '3') {
          options.cellElement.classList.add('bojaSmjena3');
        }
      }
    }
  }

  onRowClick(e) {
    if (e.rowType === 'data' && e.handled !== true) {
      var key = e.component.getKeyByRowIndex(e.rowIndex);
      var expanded = e.component.isRowExpanded(key);
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  filtrirajDokumente(e: any): void {
    //console.log(e);
    e.component.collapseAll(-1);
    e.component.expandRow(e.currentSelectedRowKeys[0]);
    this.idRadniNalog = e.selectedRowsData[0].nl_id;
    //console.log('idRadniNalog: ', this.idRadniNalog);
    this.popisDokumenataRN = [];
    let arr = [];

    for (let i = 0; i < this.rnDokumenti.length; i++) {
      if (this.rnDokumenti[i].nl_id == this.idRadniNalog) {
        //console.log(this.rnDokumenti[i].pr_broj2);

        //push-am prvo u arr jer kad push-am u varijablu popisDokumenataRN ne paše oblik (izgled) 
        //krajnjeg rezultata (data[0]...) za dx-tree-list pa baca grešku keyexpr...
        arr.push(this.rnDokumenti[i].pr_broj2);
        //console.log('arr: ', arr);
        
        this.popisDokumenataRN = arr[0];
      }
    }
    //console.log(this.popisDokumenataRN);
  }

  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiIzvjestaje(this.datumOdFormatiran, this.datumDoFormatiran);
  }

  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiIzvjestaje(this.datumOdFormatiran, this.datumDoFormatiran);
  }

  dohvatiIzvjestaje(datumod: string, datumdo: string): void {
    this.poruka = 'Učitavanje...';
    this.rnDokumenti = [];
    let data = {
      idfirma: localStorage.getItem('firma'),
      datumod: datumod,
      datumdo: datumdo,
    };
    //console.log(data);
    this.service.dohvatiIzvjestaje(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.rnDokumenti = res.data;
      }

      if (this.rnDokumenti.length > 0) {
        this.poruka = 'Učitavanje...';
      } else {
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  ngOnInit(): void {
    this.dohvatiIzvjestaje(this.datumOdFormatiran, this.datumDoFormatiran);
  }

}
